import React from 'react';

import s from './Footer.module.scss';

export const Footer = (): JSX.Element => (
  <footer className={s.footer}>
    <div className={s.footer__Item}>
      {`©  ${new Date().getFullYear()} Landsvirkjun`}
    </div>
    {/* <div className={s.footer__Item}>
      <a href="mailto:vidskiptastyring@landsvirkjun.is">
        vidskiptastyring@landsvirkjun.is
      </a>
    </div>
    <div className={s.footer__Item}>s. 515-9008</div> */}
  </footer>
);
